import { useMutation } from "@tanstack/react-query";

import { useGroupReferences } from "@contexts/GroupReferences/GroupReferences.context";

import { apiEcmsHttp } from "../http";
import { QUERY_KEYS } from "../keys";
import type { GetUserEmailCheckResponse } from "./apiEcms.types";

const getUserEmailCheck = (email: string) =>
  apiEcmsHttp.get<GetUserEmailCheckResponse>(`/users/${email}/check`);

// We use a mutation because this is a ponctual usage, onClick
// Thus, useQuery with enabled will not be pertinent because
// there shouldn't be two times the same request, no cache needed
export const useGetUserEmailCheck = () => {
  const { currentGroup } = useGroupReferences();

  return useMutation({
    mutationKey: [QUERY_KEYS.CHECK_USER_EMAIL, currentGroup],
    mutationFn: getUserEmailCheck,
  });
};
